import { ENDPOINTS } from "src/api/endpoints";

export interface PaymentRetrialResponse {
  redirect_uri: string;
}

export const getPaymentRetrialUrl = async (headers: {
  Authorization: string;
}): Promise<PaymentRetrialResponse> => {
  try {
    const response = await fetch(ENDPOINTS.PAYMENT_RETRIAL, {
      method: "GET",
      headers: {
        ...headers,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch payment retrial uri: ${response.status} ${response.statusText}`
      );
    }

    const data = (await response.json()) as PaymentRetrialResponse;
    return data;
  } catch (error) {
    console.error("Error fetching payment retrial uri:", error);
    throw error;
  }
};
